/* eslint-disable no-bitwise */
export enum ComplianceCategory {
	Any = 255,
	None = 0,
	CCPA = 1 << 0,
	COPPA = 1 << 1,
	GDPR = 1 << 2,
	HIPAA = 1 << 3,
	PCI = 1 << 4,
	PII = 1 << 6
}
